import { useContext } from 'react';

import {
  type PanelContextProps,
  PanelContext,
} from '../contexts/PanelContext.js';

/** Hook for accessing the PagePanelContext.
 * @internal
 */
export const usePanelContext = (): PanelContextProps => {
  return useContext(PanelContext);
};
